import { Component, OnInit, ViewChild } from '@angular/core';
import { QuestionAnswer } from '../_models/question-answer';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { AuthService } from '../_services/auth.service';
import { SnotifyService } from 'ng-snotify';
import { SpinnerService } from '../_core/spinner/spinner.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ValidationErrorMessageEnum } from '../constants/ValidationErrorMessageEnum';
import { QuestionAnswerService } from '../_services/question-answer.service';

@Component({
  selector: 'app-question-answer-save-update',
  templateUrl: './question-answer-save-update.component.html',
  styleUrls: ['./question-answer-save-update.component.css']
})
export class QuestionAnswerSaveUpdateComponent implements OnInit {

  questionAnswerList: QuestionAnswer[] = [];
  questionAnswerDataForm: QuestionAnswer = new QuestionAnswer();
  questionAnswerDataObj: QuestionAnswer = new QuestionAnswer();
  questionAnswerFormGroup: FormGroup;
  submitAttempt = false;
  checkUserSessionFlag = false;
  saveFlag = '';
  updateFlag = '';
  questionId: any;


  questionType: QuestiionType[] = [
    { type: 1, viewValue: 'Basic Of Patent' },
    { type: 2, viewValue: 'Patent Search' },
    { type: 3, viewValue: 'Patent Draft' }
  ];



  constructor(
    private authService: AuthService,
    private snotifyService: SnotifyService,
    private formbuilder: FormBuilder,
    private router: Router,
    private questionAnswerService: QuestionAnswerService,
    private activatedRoute: ActivatedRoute
  ) {
    this.activatedRoute.params.subscribe(params => {
      this.questionId = params['id'];
      this.updateFlag = 'true';
    });
  }

  ngOnInit() {
    this.getQuestionFormValidation();
    if (this.updateFlag == 'true' && this.questionId > 0) {
      this.getQuestionById(this.questionId);
    }
  }


  getQuestionFormValidation() {
    this.questionAnswerFormGroup = this.formbuilder.group({
      'question': new FormControl('', [
        Validators.compose([
          Validators.minLength(3),
          Validators.maxLength(400),
          Validators.required])
      ]),
      'optionOne': new FormControl('', [
        Validators.compose([
          Validators.minLength(3),
          Validators.maxLength(100),
          Validators.required])
      ]),
      'optionTwo': new FormControl('', [
        Validators.compose([
          Validators.minLength(3),
          Validators.maxLength(100),
          Validators.required])
      ]),
      'optionThree': new FormControl('', [
        Validators.compose([
          Validators.minLength(3),
          Validators.maxLength(100),
          Validators.required])
      ]),
      'optionFour': new FormControl('', [
        Validators.compose([
          Validators.minLength(3),
          Validators.maxLength(100),
          Validators.required])
      ])
      , 'answer': new FormControl('', [
        Validators.compose([
          Validators.minLength(3),
          Validators.maxLength(100),
          Validators.required])
      ]),
      'testType': new FormControl('', [
        Validators.compose([
          Validators.minLength(3),
          Validators.maxLength(10),
          Validators.required])
      ])
    });
  }

  getQuestionById(id) {
    this.questionAnswerService.getQuestionByID(id).subscribe(
      resp => {
        let respObj = resp as QuestionAnswer;
        this.questionAnswerDataForm.questionName = respObj.questionName;
        this.questionAnswerDataForm.questionId = respObj.questionId;
        this.questionAnswerDataForm.optionOne = respObj.optionOne;
        this.questionAnswerDataForm.optionTwo = respObj.optionTwo;
        this.questionAnswerDataForm.optionThree = respObj.optionThree;
        this.questionAnswerDataForm.optionFour = respObj.optionFour;
        this.questionAnswerDataForm.answer = respObj.answer;
        this.questionAnswerDataForm.testType = respObj.testType;
      }, error => {
        console.log(error);
        this.snotifyService.error(error);
      })
  }

  getErrorMsgForQuestionAnswerError() {
    return this.questionAnswerFormGroup.controls.question.errors.required ? ValidationErrorMessageEnum.REQUIRED :
      this.questionAnswerFormGroup.controls.question.errors.minlength ? ValidationErrorMessageEnum.MIN_LENGTH_THREE :
        this.questionAnswerFormGroup.controls.question.errors.maxlength ? ValidationErrorMessageEnum.MAX_LENGTH_TEN :
          '';
  }

  submitQuestionAnswer() {

    if (this.questionAnswerFormGroup.valid) {
      // Show Spinner
      this.questionAnswerService.saveAndUpdate(this.questionAnswerDataForm).subscribe(
        resp => {
          this.router.navigate(['/questionAnswerList']);
        });
      error => {
        console.log(error);
        this.snotifyService.error(error);
      }
    } else {
      console.log("Error")
    }
  }
}

export interface QuestiionType {
  type: number;
  viewValue: string;
}
